<template>
	<div id="historico" class="relative">

		<stopwatch
			v-if="$permissions.can('timeworkedvisualizar') || $permissions.can('autenticadosuperuser')"
			:prazo="prazo"
			:onPaused="getHistorico"
			:onStarted="getHistorico"
		/>

		<vx-card class="historico-container">
			<div class="header-sidebar" >
				<h4 class="subtitle mt-10 mb-4 font-bold">Histórico</h4>
			</div>
			<VuePerfectScrollbar
				class="historico-scroll-area"
				:settings="settingsPerfectScroll"
			>
				<div class="w-full h-full">
					<div class="historico-quill-editor quill-editor">
						<div class="ql-container ql-snow">
							<div class="ql-editor">

								<div class="registro" v-for="(registro, indexRegistro) in registros" :key="registro.pk">
									<vs-avatar :src="registro.usuario ? registro.usuario.foto_thumb : ''"/>
									<div class="registro-content">

										<div v-if="registro.usuario && registro.usuario.nome" class="historico-usuario">
											<div class="flex flex-col">
												<p class="historico-usuario__nome">{{ registro.usuario.nome }}</p>
												<h5 v-if="registro.created_at">{{ registro.created_at }}</h5>
											</div>
										</div>

										<div v-else-if="!registro.comentario && (!registro.anexos || (registro.anexos && !registro.anexos.length))" class="historico-descricao">
											<h3>Sistema Agenda</h3>
											<h5 v-if="!registro.usuario && registro.created_at">{{ registro.created_at }}</h5>
										</div>

										<div v-if="registro.comentario && registro.comentario.mensagem" class="historico-comentario">

											<div v-if="registro.comentario.is_active && registroEditar.pk == registro.pk" :id="`registro-edicao-${registro.id}`" class="registro-edicao p-5">
												<quill-editor
													v-model="registroEditar.content"
													:options="editorOption"
												>
													<div
														id="toolbar"
														slot="toolbar"
														class="flex justify-between"
													>
														<!-- Add a bold button -->
														<div>
															<button class="ql-bold"></button>
															<button class="ql-italic"></button>
															<button class="ql-underline"></button>

															<button
																class="ql-list"
																value="ordered"
															></button>
															<button class="ql-list" value="bullet"></button>

															<select class="ql-color" title="Colour">
																<option value="rgb(0, 0, 0)" selected />
																<option
																	:value="color"
																	v-for="color in colors"
																	:key="color"
																/>
															</select>
														</div>
													</div>
												</quill-editor>
												<div class="flex justify-end pt-3">
													<ld-button
														color="#c3c3c3"
														class="w-1/2 mr-3"
														@click="fecharEdicaoComentario"
													>
														Cancelar
													</ld-button>
													<ld-button
														color="success"
														class="w-1/2"
														@click="() => editarRegistro(registro.comentario.pk, registro.id, indexRegistro)"
													>
														Salvar
													</ld-button>
												</div>
											</div>

											<div v-else-if="registro.comentario.is_active">
												<div class="historico-comentario--content" v-html="registro.comentario.mensagem"></div>
												<h6 v-if="registro.comentario && registro.comentario.editado" class="historico-comentario--editado">(editado)</h6>
											</div>

											<div v-else>
												<h4><i>[ Comentário excluído ]</i></h4>
											</div>
										</div>

										<div v-else-if="registro.anexos && registro.anexos.length" class="historico-anexos">
											<template v-for="(anexo, indexAnexo) in registro.anexos">
												<div class="relative" :key="indexAnexo">
													<vx-card class="historico-anexos--file" >
														<div class="flex items-center p-5">

															<img class="file-icon" :src="anexo.excluido ? getIconFile('deleted') : getIconFile(getExtension(anexo.nome_original))">
															<div class="flex flex-col flex-1 overflow-hidden">
																<h4 class="file-name ml-3">{{ anexo.nome_original }}</h4>
																<div class="flex items-center ml-3 mt-3">
																	<!-- <h5 v-if="!anexo.excluido" class="text-base mr-3">24 KB</h5> -->
																	<h5 v-if="!anexo.excluido" class="file-extension text-base mr-5">{{getExtension(anexo.nome_original)}}</h5>
																	<button v-if="!anexo.excluido" class="text-sm border-none bg-transparent cursor-pointer underline" @click="() => baixarAnexo(anexo.arquivo, anexo.nome_original)">
																		Baixar anexo
																	</button>
																	<h4 v-if="anexo.excluido"><i>[ Anexo excluído ]</i></h4>
																</div>
															</div>
														</div>
													</vx-card>
													<vs-dropdown v-if="!anexo.excluido && ($permissions.can('anexoexcluir') || $permissions.can('autenticadosuperuser'))" class="registro-menu-opcoes">
														<vs-icon icon="more_horiz"></vs-icon>
														<vs-dropdown-menu>
															<vs-dropdown-item v-if="$permissions.can('anexoexcluir') || $permissions.can('autenticadosuperuser')" @click="() => abrirPopupExcluirAnexo(anexo, indexAnexo, indexRegistro)">Excluir</vs-dropdown-item>
														</vs-dropdown-menu>
													</vs-dropdown>
												</div>
											</template>
										</div>

										<div v-else-if="registro.descricao && registro.situacao" class="historico-situacao">
											<p class="break-all">{{ registro.descricao }} para: {{ registro.situacao }}</p>
										</div>

										<div v-else-if="registro.descricao && !registro.situacao" class="historico-situacao">
											<p class="break-all">{{ registro.descricao }}</p>
										</div>

										<div v-else-if="!registro.descricao && registro.situacao" class="historico-situacao">
											<p class="break-all">{{ registro.situacao }}</p>
										</div>

									</div>

									<vs-dropdown v-if="registro.comentario && registro.comentario.is_active && registro.comentario.mensagem && usuarioAutenticado.pk == registro.comentario.autor.pk" class="registro-menu-opcoes">
										<vs-icon icon="more_horiz"></vs-icon>
										<vs-dropdown-menu>
											<vs-dropdown-item v-if="$permissions.can('comentariomodificar') || $permissions.can('autenticadosuperuser')" @click="() => editarComentario(registro)">Editar</vs-dropdown-item>
											<vs-dropdown-item v-if="$permissions.can('comentarioexcluir') || $permissions.can('autenticadosuperuser')" @click="() => excluirComentario(registro, indexRegistro)">Excluir</vs-dropdown-item>
										</vs-dropdown-menu>
									</vs-dropdown>
								</div>
							</div>
						</div>
					</div>

					<div class="container-registro py-5" v-if="$permissions.can('comentarioadicionar') || $permissions.can('autenticadosuperuser')">
						<quill-editor
							v-model="registro.content"
							:options="editorOption"
						>
							<div
								id="toolbar"
								slot="toolbar"
								class="flex justify-between"
							>
								<!-- Add a bold button -->
								<div>
									<button class="ql-bold"></button>
									<button class="ql-italic"></button>
									<button class="ql-underline"></button>

									<button
										class="ql-list"
										value="ordered"
									></button>
									<button class="ql-list" value="bullet"></button>

									<select class="ql-color" title="Colour">
										<option value="rgb(0, 0, 0)" selected />
										<option
											:value="color"
											v-for="color in colors"
											:key="color"
										/>
									</select>
								</div>

								<button v-if="false" class="button-anexo" @click="triggerInput">
									<input type="file" name="attachment" />
									<feather-icon icon="PaperclipIcon" />
								</button>
							</div>
						</quill-editor>
					</div>

					<vs-checkbox v-if="($permissions.can('comentarioadicionar') || $permissions.can('autenticadosuperuser')) && false" class="mb-8 px-5" v-model="registro.notificacao"
						>Enviar notificação para o responsável?</vs-checkbox
					>

					<div v-if="$permissions.can('comentarioadicionar') || $permissions.can('autenticadosuperuser')" class="flex justify-end mb-5">
						<ld-button
							color="primary"
							type="filled"
							class="w-full mb-4"
							@click="() => adicionarRegistro()"
						>
							Adicionar registro
						</ld-button>
					</div>
				</div>
			</VuePerfectScrollbar>
		</vx-card>

		<vx-card class="mt-8">
			<div class="ultimos-anexos">
				<h4 class="subtitle mt-10 mb-4 font-bold">Últimos anexos</h4>

				<div v-if="ultimosAnexos && ultimosAnexos.length" class="listagem-ultimos-anexos">
					<div class="relative" v-for="(anexo, indexAnexo) in ultimosAnexos" :key="indexAnexo">
						<vx-card class="ultimos-anexos--file" >
							<div class="flex items-center p-5">
								<img class="file-icon" :src="anexo.excluido ? getIconFile('deleted') : getIconFile(getExtension(anexo.nome_original))">
								<div class="flex flex-col flex-1 overflow-hidden">
									<h4 class="file-name ml-3">{{ anexo.nome_original }}</h4>
									<div class="flex flex-wrap items-center ml-3 mt-3">
										<h5 v-if="!anexo.excluido" class="text-base mr-5 mb-1">{{anexo.autor.nome}}</h5>
										<h5 v-if="!anexo.excluido" class="text-base mr-5 mb-1">{{anexo.created_at}}</h5>
									</div>
									<div class="flex items-center ml-3">
										<h5 v-if="!anexo.excluido" class="file-extension text-base mr-5">{{getExtension(anexo.nome_original)}}</h5>
										<button v-if="!anexo.excluido" class="text-sm border-none bg-transparent cursor-pointer underline" @click="() => baixarAnexo(anexo.arquivo, anexo.nome_original)">
											Baixar anexo
										</button>
									</div>
								</div>
							</div>
						</vx-card>
						<vs-dropdown v-if="!anexo.excluido && ($permissions.can('anexoexcluir') || $permissions.can('autenticadosuperuser'))" class="registro-menu-opcoes">
							<vs-icon icon="more_horiz"></vs-icon>
							<vs-dropdown-menu>
								<vs-dropdown-item v-if="$permissions.can('anexoexcluir') || $permissions.can('autenticadosuperuser')" @click="() => abrirPopupExcluirAnexo(anexo, null, null, true)">Excluir</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>
				</div>

				<div v-if="ultimosAnexos && !ultimosAnexos.length" class="sem-anexos">
					<h5>Nenhum anexo foi enviado</h5>
				</div>

				<div class="w-full my-4">
					<ld-button
						color="primary"
						type="border"
						class="button-ver-todos-anexos"
						@click="abrirPopupVerTodosAnexos"
					>
						Ver todos os anexos
					</ld-button>
				</div>
				<div class="w-full">
					<ld-button
						color="primary"
						class="w-full"
						@click="popupAdicionarAnexo = true"
					>
						Enviar novo anexo
					</ld-button>
				</div>
			</div>
		</vx-card>

		<ld-popup
			id="popup-excluir-registro"
			title="Exclusão de comentário"
			:active.sync="popupExcluirRegistro"
			:button-close-hidden="true"
			:disabledBackgoundClose="true"
		>
			<p>Tem certeza que deseja excluir o comentário?</p>

			<template v-if="registroExcluir">
				<div class="historico-quill-editor quill-editor">
					<div class="ql-container ql-snow">
						<div class="ql-editor">
							<div class="p-5" v-html="registroExcluir.comentario.mensagem"></div>
						</div>
					</div>
				</div>
			</template>

			<vs-divider />

			<div class="button-container">
				<div class="button-group flex justify-end">
					<vs-button
						class="w-64 mr-4"
						color="dark"
						type="flat"
						@click="fecharExclusaoRegistro"
						>Cancelar</vs-button
					>

					<vs-button
						class="w-64"
						color="danger"
						type="filled"
						@click="excluirRegistro"
						>Excluir</vs-button
					>
				</div>
			</div>
		</ld-popup>

		<ld-popup
			id="popup-excluir-anexo"
			title="Exclusão de anexo"
			:active.sync="popupExcluirAnexo"
			:button-close-hidden="true"
			:disabledBackgoundClose="true"
		>
			<p>Tem certeza que deseja excluir o anexo <strong><i>{{ anexoExcluir ? anexoExcluir.nome_original : "" }}</i></strong>?</p>

			<vs-divider />

			<div class="button-container">
				<div class="button-group flex justify-end">
					<vs-button
						class="w-64 mr-4"
						color="dark"
						type="flat"
						@click="fecharExclusaoAnexo"
						>Cancelar</vs-button
					>

					<vs-button
						class="w-64"
						color="danger"
						type="filled"
						@click="excluirAnexo"
						>Excluir</vs-button
					>
				</div>
			</div>
		</ld-popup>

		<ld-popup
			id="popup-adicionar-anexo"
			title=""
			:active.sync="popupAdicionarAnexo"
			:button-close-hidden="true"
			:disabledBackgoundClose="true"
		>
			<div class="flex justify-between items-center mb-4">
				<h3 class="font-bold">Enviar novos anexos</h3>
				<ld-button
					icon-pack="feather"
					icon="icon-x"
					size="large"
					color="dark"
					type="flat"
					class="header-button-close ml-4"
					@click="() => popupAdicionarAnexo = false"
				></ld-button>
			</div>
			<anexos
				v-if="(!prazoPerdido && $permissions.can('anexoadicionar')) || $permissions.can('autenticadosuperuser')"
				class="py-5"
				:onSend="() => {
					getUltimosAnexos();
					getHistorico();
					popupAdicionarAnexo = false;
				}"
				:showEnviarAnexos="true"
				:flat="true"
				:hiddenLabel="true"
				:prazoPk="prazo.pk"
				:anexos.sync="prazo.anexos"/>
		</ld-popup>

		<ld-popup
			id="popup-ver-todos-anexos"
			title=""
			:active.sync="popupVerTodosAnexos"
			:button-close-hidden="true"
			:disabledBackgoundClose="true"
			:fullscreen="true"
		>
			<div class="ver-todos-anexos-container overflow-x-auto w-full h-full">
				<div class="p-5 mb-4">
					<div class="flex justify-between">
						<h3 class="font-bold">Anexos</h3>
						<ld-button
							icon-pack="feather"
							icon="icon-x"
							size="large"
							color="dark"
							type="flat"
							class="header-button-close ml-4"
							@click="() => popupVerTodosAnexos = false"
						></ld-button>
					</div>
				</div>

				<div class="ver-todos-anexos m-0 vx-row match-height">
					<div class="relative vx-col lg:w-1/3 sm:w-1/2 w-full" v-for="anexo in anexos" :key="anexo.pk">
						<vx-card class="ver-todos-anexos--file" >
							<div class="flex items-center p-5">
								<img class="file-icon" :src="anexo.excluido ? getIconFile('deleted') : getIconFile(getExtension(anexo.nome_original))">
								<div class="flex flex-col flex-1 overflow-hidden">
									<h4 class="file-name ml-3">{{ anexo.nome_original }}</h4>
									<div class="flex flex-wrap items-center ml-3 mt-3">
										<h5 v-if="!anexo.excluido" class="text-base mr-5 mb-1">{{anexo.autor.nome}}</h5>
										<h5 v-if="!anexo.excluido" class="text-base mr-5 mb-1">{{anexo.created_at}}</h5>
									</div>
									<div class="flex items-center ml-3">
										<h5 v-if="!anexo.excluido" class="file-extension text-base mr-5">{{getExtension(anexo.nome_original)}}</h5>
										<button v-if="!anexo.excluido" class="text-sm border-none bg-transparent cursor-pointer underline" @click="() => baixarAnexo(anexo.arquivo, anexo.nome_original)">
											Baixar anexo
										</button>
									</div>
								</div>
							</div>
						</vx-card>
					</div>
				</div>
			</div>

			<div class="p-4">
				<ld-pagination
					v-if="anexos.length"
					:currentPage.sync="paginationAnexos.currentPage"
					:offset.sync="paginationAnexos.offset"
					:pageSize="paginationAnexos.pageSize"
					:dataLength="paginationAnexos.dataLength"
				/>
			</div>
		</ld-popup>

	</div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import Prazo, { Situacao } from '../../../../../../models/Prazo';
import DateHelper from '../../../../../../helpers/DateHelper';
import StringHelper from '../../../../../../helpers/StringHelper';
import AssetsHelper from '../../../../../../helpers/AssetsHelper';
import Usuario from '../../../../../../models/Usuario';
import scrollInfinito from '../../../../../../helpers/getDataByScroll';

import Anexos from "../anexos/Anexos";
import LdPagination from "../../../../../../components/ld-pagination/LdPagination";
import Stopwatch from '../stopwatch/Stopwatch.vue';

export default {
	data() {
		return {
			paginationAnexos: this.initialPaginationAnexos(),
			popupVerTodosAnexos: false,
			popupAdicionarAnexo: false,
			popupExcluirRegistro: false,
			registroExcluir: null,
			popupExcluirAnexo: false,
			anexoExcluir: null,
			registros: [],
			ultimosAnexos: [],
			anexos: [],
			registroEditar: {
				pk: null,
				content: null,
			},
			registro: {
				content: null,
				notificacao: null,
			},
			editorOption: {
				modules: {
					toolbar: "#toolbar"
				},
				placeholder: ""
			},
			colors: [
				"#e60000",
				"#ff9900",
				"#ffff00",
				"#008a00",
				"#0066cc",
				"#9933ff",
				"#ffffff",
				"#facccc",
				"#ffebcc",
				"#ffffcc",
				"#cce8cc",
				"#cce0f5",
				"#ebd6ff",
				"#bbbbbb",
				"#f06666",
				"#ffc266",
				"#ffff66",
				"#66b966",
				"#66a3e0",
				"#c285ff",
				"#888888",
				"#a10000",
				"#b26b00",
				"#b2b200",
				"#006100",
				"#0047b2",
				"#6b24b2",
				"#444444",
				"#5c0000",
				"#663d00",
				"#666600",
				"#003700",
				"#002966",
				"#3d1466"
			],
			settingsPerfectScroll: {
				// perfectscrollbar settings
				suppressScrollX: true,
				wheelSpeed: 0.2
			},
			historicoConfigs: {
                isLoading: false,
				listSize: 20,
				filters: {
					limit: 20,
				},
                currentPage: 1,
                isMaxPage: false,
			},
			waitElement: null,
			waitScrollElement: null,
		};
	},
	components: {
		quillEditor,
		Anexos,
		LdPagination,
		Stopwatch,
	},
	props: {
		prazoPk: {
			required: true,
		},
		prazo: {
			required: true,
		},
		atualizar: {
			required: false,
		},
		prazoPerdido: {
			required: true
		},
		initialData: {
			required: true,
		}
	},
	computed: {
		usuarioAutenticado() {
			return Usuario.getUsuarioAutenticado();
		},
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		getIconFile() {
			return AssetsHelper.getFileIcon;
		}
	},
	methods: {
		initialPaginationAnexos() {
			return {
				currentPage: 1,
				offset: 0,
				pageSize: 20,
				dataLength: 0
			};
		},
		async adicionarRegistro() {

			if (!this.registro.content) {
				return;
			}

			const loadingHistorico = this.$vsloading({
				container: "#historico",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {

				let mensagem = JSON.parse(JSON.stringify(this.registro.content));
				this.registro.content = "";

				await Prazo.adicionarComentario(this.empresaPk, this.prazo.pk, mensagem);
				await this.getHistorico(true);

			} catch (error) {
				console.error(error);
			} finally {
				loadingHistorico.hide();
			}
		},
		async getHistorico(withoutLoading) {

			let loadingHistorico = null;

			if (!withoutLoading) {
				loadingHistorico = this.$vsloading({
					container: "#historico",
					color: "#000000",
					backgroundColor: "#ffffffba",
					opacity: 1,
					width: 44,
					height: 44
				});
			}

			try {

				const { historico } = await Prazo.getHistorico(this.empresaPk, this.prazo.pk, {limit: this.historicoConfigs.filters.limit});

				this.registros = historico.map(registro => {
					return {
						...registro,
						created_at: DateHelper.convertDate(
							registro.created_at,
							null,
							"DD/MM/YYYY [as] HH:mm"
						),
						situacao: Situacao.getNome(registro.situacao),
						id: StringHelper.onlyNumbers(registro.pk)
					}
				});

				this.defaultHistoricoConfigs();
				this.scrollToEnd();


			} catch (error) {
				console.error(error);
			} finally {
				if (loadingHistorico) {
					loadingHistorico.hide();
				}
			}
		},
		async moreHistorico(params) {

            const data = {
                count: 0,
                data: []
            }

            try {

                if (!params) {
                    params = {limit: 20};
                }

                const { historico, totalHistorico } = await Prazo.getHistorico(this.empresaPk, this.prazo.pk, params);

                data.data = historico.map(registro => {
					return {
						...registro,
						created_at: DateHelper.convertDate(
							registro.created_at,
							null,
							"DD/MM/YYYY [as] HH:mm"
						),
						situacao: Situacao.getNome(registro.situacao),
						id: StringHelper.onlyNumbers(registro.pk)
					}
				});

                data.count = totalHistorico;

            } catch (error) {
				console.error(error);
            }

            return data;
        },
		async scrollListener(event) {

            this.historicoConfigs['getData'] = this.moreHistorico;

            let data = await scrollInfinito.run(event, this.historicoConfigs, true);

			if (data) {
				this.registros = [
					...this.registros,
					...data
				];
			}
		},
		scrollToEnd() {
			this.waitElement = setInterval(() => {
				try {
					const $historicoContent = this.$el.querySelector(".historico-quill-editor .ql-editor");

					if ($historicoContent) {
						$historicoContent.scrollTop = $historicoContent.scrollHeight;
						clearInterval(this.waitElement);
					}

				} catch (error) {
					console.error(error);
				}
			}, 1000);
		},
		triggerInput(event) {
			const $buttonAnexo = event.target;

			if ($buttonAnexo) {
				const $input = $buttonAnexo.querySelector("input");

				if ($input) {
					$input.click();
				}
			}
		},
		editarComentario(registro) {
			this.registroEditar.pk = registro.pk;
			this.registroEditar.content = registro.comentario.mensagem;
		},
		fecharEdicaoComentario() {
			this.registroEditar.pk = null;
			this.registroEditar.content = null;
		},
		async editarRegistro(comentarioPk, registroId, indexRegistro) {
			const loadingRegistro = this.$vsloading({
				container: `#registro-edicao-${registroId}`,
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				let mensagem = JSON.parse(JSON.stringify(this.registroEditar.content));

				const comentario = await Prazo.editarComentario(this.empresaPk, this.prazo.pk, comentarioPk, mensagem);

				this.registros[indexRegistro].comentario.mensagem = comentario.mensagem;
				this.registros[indexRegistro].comentario.editado = comentario.editado;
				this.fecharEdicaoComentario();

			} catch (error) {
				console.error(error);
			} finally {
				loadingRegistro.hide();
			}
		},
		excluirComentario(registro, index) {
			this.registroExcluir = {
				...registro,
				index
			};
			this.popupExcluirRegistro = true;
		},
		fecharExclusaoRegistro() {
			this.registroExcluir = null;
			this.popupExcluirRegistro = false;
		},
		async excluirRegistro() {
			const loadingRegistro = this.$vsloading({
				container: `#popup-excluir-registro`,
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {

				await Prazo.excluirComentario(this.empresaPk, this.prazo.pk, this.registroExcluir.comentario.pk);
				this.registros[this.registroExcluir.index].comentario.mensagem = "<i>[ Comentário excluído ]</i>";
				this.registros[this.registroExcluir.index].comentario.is_active = false;
				this.fecharExclusaoRegistro();

			} catch (error) {
				console.error(error);
			} finally {
				loadingRegistro.hide();
			}
		},
		defaultHistoricoConfigs() {
            this.historicoConfigs = {
                isLoading: false,
				listSize: 20,
				filters: {
					limit: 20,
				},
                currentPage: 1,
                isMaxPage: false,
            };
		},
		getExtension(nome) {
			const split = nome.split(".");
			if (split.length) {
				return split[split.length - 1].toUpperCase();
			}

			return "File";
		},
		async baixarAnexo(fileUrl, filename) {
			const loadingHistorico = this.$vsloading({
				container: this.popupVerTodosAnexos ? "#popup-ver-todos-anexos .vs-popup--content" : "#historico",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});
			try {
				const anexoFileResponse = await Prazo.baixarAnexo(fileUrl);

				const element = document.createElement('a');
                const blob = new Blob([anexoFileResponse.request.response]);

                element.setAttribute('href', window.URL.createObjectURL(blob));
                element.setAttribute('download', filename);

                element.style.display = 'none';
                document.body.appendChild(element);

                element.click();

                element.remove();

			} catch (error) {
				console.error(error);
			} finally {
				setTimeout(loadingHistorico.hide, 200);
			}

		},
		abrirPopupExcluirAnexo(anexo, indexAnexo, indexRegistro, isUltimosAnexos = false) {
			this.anexoExcluir = {
				...anexo,
				indexAnexo,
				indexRegistro,
				isUltimosAnexos
			};

			this.popupExcluirAnexo = true;
		},
		fecharExclusaoAnexo() {
			this.anexoExcluir = null;
			this.popupExcluirAnexo = false;
		},
		async excluirAnexo() {

			const loadingHistorico = this.$vsloading({
				container: "#popup-excluir-anexo",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Prazo.excluirAnexo(this.empresaPk, this.prazo.pk, this.anexoExcluir.pk);

				if (this.anexoExcluir.isUltimosAnexos) {
					this.getHistorico();
				} else {
					this.registros[this.anexoExcluir.indexRegistro].anexos[this.anexoExcluir.indexAnexo].excluido = true;
				}
				this.getUltimosAnexos();
				this.fecharExclusaoAnexo();

			} catch (error) {
				console.error(error);
			} finally {
				setTimeout(loadingHistorico.hide, 200);
			}

		},
		async getUltimosAnexos() {

			const loadingUltimosAnexos = this.$vsloading({
				container: ".ultimos-anexos",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				const { anexos } = await Prazo.anexos(this.empresaPk, this.prazoPk, {limit: 3});

				this.ultimosAnexos = anexos.map(anexo => {
					return {
						...anexo,
						created_at: DateHelper.convertDate(
							anexo.created_at,
							null,
							"DD/MM/YYYY [as] HH:mm"
						),
					}
				});

			} catch (error) {
				console.error(error);
			} finally {
				setTimeout(loadingUltimosAnexos.hide, 200);
			}

		},
		abrirPopupVerTodosAnexos() {
			this.popupVerTodosAnexos = true;
			this.anexos = [];
			this.paginationAnexos = this.initialPaginationAnexos();
			this.getAnexos();
		},
		async getAnexos() {

			const loadingAnexos = this.$vsloading({
				container: "#popup-ver-todos-anexos",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {

				const params = {
					offset: this.paginationAnexos.offset,
					limit: this.paginationAnexos.pageSize,
				};

				const { anexos, totalAnexos } = await Prazo.anexos(
					this.empresaPk,
					this.prazoPk,
					params
				);
				this.anexos = anexos.map(anexo => {
					return {
						...anexo,
						created_at: DateHelper.convertDate(
							anexo.created_at,
							null,
							"DD/MM/YYYY [as] HH:mm"
						),
					}
				});
				this.paginationAnexos.dataLength = totalAnexos;

			} catch (error) {
				console.error(error);
			} finally {
				setTimeout(loadingAnexos.hide, 200);
			}

		},
		setInitialData() {
			this.registros = this.initialData.map(registro => {
				return {
					...registro,
					created_at: DateHelper.convertDate(
						registro.created_at,
						null,
						"DD/MM/YYYY [as] HH:mm"
					),
					situacao: Situacao.getNome(registro.situacao),
					id: StringHelper.onlyNumbers(registro.pk)
				}
			});

			this.defaultHistoricoConfigs();
			this.scrollToEnd();
		}
	},
	watch: {
		atualizar() {
			this.getHistorico();
		},
		"paginationAnexos.currentPage": function() {
			this.getAnexos();
		},
	},
	beforeDestroy() {
		const $historicoContent = this.$el.querySelector(".historico-quill-editor .ql-editor");

		if ($historicoContent) {
			$historicoContent.removeEventListener("scroll", this.scrollListener);
		}

		if (this.waitElement) {
			clearInterval(this.waitElement);
		}

		if (this.waitScrollElement) {
			clearInterval(this.waitScrollElement);
		}
	},
	mounted() {
		this.setInitialData();
		this.getUltimosAnexos();



		this.waitScrollElement = setInterval(() => {
			try {
				const $historicoContent = this.$el.querySelector(".historico-quill-editor .ql-editor");

				if ($historicoContent) {
					$historicoContent.addEventListener("scroll", this.scrollListener);
					clearInterval(this.waitScrollElement);
				}
			} catch (error) {
				console.error(error);
			}
		}, 1000);
	},
};
</script>

<style lang="scss" src="./historico.scss"></style>
